import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

const propTypes = {
  location: PropTypes.string,
  weather: PropTypes.array,
};

const defaultProps = {
  title: 'Bald Eagle Cam Partner Facts',
  body: 'Dummy text'
};

class InfoPanel extends React.Component {

  generateHtml () {
    return {__html: this.props.body};
  }

  render() {
    return (
      <div className="widget panel info">
          <div className="info-box-header container-top-rounded text-uppercase u-font-foundation-bold u-textSize-18">
            <div className="info-box-title">{this.props.title}</div>
            <div className="info-box-collapse">arrow</div>
          </div>
          <div className="info-box-content p-30">
            <div className="text-justify" dangerouslySetInnerHTML={this.generateHtml()} />
          </div>
      </div>
    );
  }

}

const mapStateToProps = (state) => {
  return {
    body: state.currentItem.data.description,
    title: state.currentItem.data.h2_title
  };
}

InfoPanel.propTypes = propTypes;
InfoPanel.defaultProps = defaultProps;

export default connect(mapStateToProps)(InfoPanel);
